import { render } from "./GuestRewardPrompt.vue?vue&type=template&id=7c586872&scoped=true"
import script from "./GuestRewardPrompt.vue?vue&type=script&lang=js"
export * from "./GuestRewardPrompt.vue?vue&type=script&lang=js"

import "./GuestRewardPrompt.vue?vue&type=style&index=0&id=7c586872&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c586872"]])

export default __exports__